module.exports = {"fr-FR":{"components":{"proposal-overlay":{"info":{"title":"Détails du fournisseur"}}}}}